import { Module } from 'vuex';
const AccessModule: Module<any, any> = {
    state: {
    }
};
export default AccessModule;
